export default __webpack_public_path__ + "static/genova-4-4d2561bc8975c3f6f7cb431d87cd72d8.jpg";